import React from "react";
import { Checkbox, ListGroupItem } from "react-bootstrap";
import { SETTINGS_VIEW_TYPES } from "../constants";
import SortIcon from "../../components/Icons/SortIcon";

const SettingViewItem = ({ item, onChange }) => {
    return (
        <ListGroupItem
            style={{
                padding: '0 15px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}
        >
            <Checkbox
                name={item.value}
                checked={item.show}
                onChange={(e) => onChange(item.value, e.target.checked)}
            >
                &nbsp; {SETTINGS_VIEW_TYPES[item.value]}
            </Checkbox>
            <SortIcon />
        </ListGroupItem>
    );
};

export default SettingViewItem;
